<div [formGroup]="form">

  <div *ngFor="let dto of overrides; let i = index;" class="mt-5" style="min-height:27px;">
    <div *ngIf="dto" class="row mt-1">
      <span class="day-label">{{ dto.date  | date:'dd.MM.yyyy' }}</span>
      <a (click)="toggle(i, $event)" class="item-link noselect">
        <div class="form-check form-switch mr-3">
          <input [id]="'toggle'+i" [ngModelOptions]="{standalone: true}" [ngModel]="dto.dailyHourRange !== null" class="form-check-input"
                 type="checkbox">
          <label [for]="'toggle'+i" class="form-check-label">
            {{(dto.dailyHourRange !== null ? 'lang.weeklySchedule.open' : 'lang.weeklySchedule.closed') | translate}}
          </label>
        </div>
      </a>
      <div *ngIf="dto.dailyHourRange !== null" class="ml-5" style="margin-top:-10px;">
        <div *ngFor="let hourRange of dto.dailyHourRange.hourRanges; let r = index"
             [class]="'row d-flex align-items-center ' + (r > 0 ? 'mt-1' : null)">
          <div class="col-3 validateMe">
            <input (focusout)="onChange(i, r, 'from', $event)"
                   [class]="'form-control ' + (hasError(i, r, 'from')  ? 'border border-danger text-danger' : '') "
                   [formControlName]="i + '_' + r + '_from'"
                   [value]="getTimeString(i, r, 'from')"
                   type="text">
          </div>
          <span class="separator"></span>
          <div class="col-3 validateMe">
            <input (focusout)="onChange(i, r, 'till', $event)"
                   [class]="'form-control ' + (hasError(i, r, 'till')  ? 'border border-danger text-danger' : '') "
                   [formControlName]="i + '_' + r + '_till'"
                   [value]="getTimeString(i, r, 'till')"
                   type="text">
          </div>
          <a (click)="removeTimeRange(i, r)" class="noselect hoverbg">
            <sb-icon class="m-0 p-3 hoverbg" icon="cancel" style="font-size: 8px;"></sb-icon>
          </a>
        </div>
        <ng-container *ngIf="!hasValidRanges(i); else rangesValid">
          <div class="alert alert-danger mt-2">{{ 'lang.openingHour.timeOverlapError' | translate }}</div>
          <a (click)="addTimeRange(i)" class="item-link noselect btn-add hoverbg" style="margin-top:31px;">
            {{'lang.weeklySchedule.addTime' | translate}}
          </a>
        </ng-container>
        <ng-template #rangesValid>
          <a (click)="addTimeRange(i)" class="item-link noselect btn-add hoverbg mt-2">
            {{'lang.weeklySchedule.addTime' | translate}}
          </a>
        </ng-template>
      </div>
      <a (click)="removeOverride(i)" *ngIf="dto.dailyHourRange === null" class="noselect hoverbg ml-3" style="margin-top:-9px;">
        <sb-icon class="m-0 p-3 hoverbg" icon="cancel" style="font-size: 8px;"></sb-icon>
      </a>
    </div>
  </div>
</div>
<div [class]="'d-flex col-3 ' + (overrides?.length > 0 ? 'mt-6' : 'mt-5')" style="margin-left:-25px;">
  <sb-local-date-input (modelChange)="newDateInputChanged($event)" [model]="newDateInputValue"></sb-local-date-input>
  <button (click)="addDateFromInput()" [disabled]="!isNewDateInputValid()" class="btn btn-primary ml-3 p-2">
    <sb-icon icon="plus"></sb-icon>
  </button>
</div>
